<template>
  <div class="config-management">
    <el-card class="box-card">
      <div slot="header" class="clearfix">
        <span>系统配置</span>
        <div style="float: right;">
          <el-button size="small" type="primary" @click="handleAdd">新增配置</el-button>
        </div>
      </div>
      <el-table :data="configs" style="width: 100%" v-loading="loading">
        <el-table-column prop="id" label="ID" width="100"></el-table-column>
        <el-table-column prop="configKey" label="键名"></el-table-column>
        <el-table-column prop="configValue" label="值"></el-table-column>
        <el-table-column prop="description" label="描述" show-overflow-tooltip></el-table-column>
        <el-table-column label="操作" width="180">
          <template slot-scope="scope">
            <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
            <el-button size="mini" type="danger" @click="handleDelete(scope.row)">删除</el-button>
          </template>
        </el-table-column>
      </el-table>
      <div v-if="!loading && configs.length === 0" class="empty-state">
        <el-empty description="暂无配置数据">
          <el-button type="primary" @click="handleAdd">添加配置</el-button>
        </el-empty>
      </div>
    </el-card>
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible" width="600px">
      <el-form :model="form" :rules="rules" ref="form" label-width="100px">
        <el-form-item label="键名" prop="configKey">
          <el-input v-model="form.configKey"></el-input>
        </el-form-item>
        <el-form-item label="值" prop="configValue">
          <el-input v-model="form.configValue" placeholder="请输入配置值或上传图片"></el-input>
          <div style="margin-top: 10px;">
            <el-upload
              action="#"
              :http-request="handleCustomUpload"
              :before-upload="beforeUpload"
              :show-file-list="false">
              <el-button size="small" type="primary">上传图片</el-button>
              <div slot="tip" class="el-upload__tip">支持 jpg/png 图片，大小不超过 10MB</div>
            </el-upload>
            <div v-if="form.configValue && isImageUrl(form.configValue)" class="uploaded-preview" style="margin-top: 10px;">
              <img :src="form.configValue" class="preview-img" @click="previewImage(form.configValue)">
            </div>
          </div>
        </el-form-item>
        <el-form-item label="描述" prop="description">
          <el-input type="textarea" v-model="form.description"></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="handleSubmit">确定</el-button>
      </div>
    </el-dialog>
    <el-dialog title="图片预览" :visible.sync="previewVisible" width="800px">
      <div class="media-container">
        <img :src="previewUrl" class="preview-full-img">
      </div>
    </el-dialog>
  </div>
</template>
<script>
import { configApi, uploadApi } from '@/api'
export default {
  name: 'ConfigManagement',
  data() {
    return {
      configs: [],
      loading: false,
      dialogVisible: false,
      dialogTitle: '新增配置',
      previewVisible: false,
      previewUrl: '',
      form: {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      },
      rules: {
        configKey: [{ required: true, message: '请输入键名', trigger: 'blur' }],
        configValue: [{ required: true, message: '请输入值', trigger: 'blur' }]
      }
    }
  },
  computed: {
    // 判断是否是背景图配置
    isBackgroundConfig() {
      const key = this.form.configKey.toLowerCase()
      return key.includes('background') || 
             key.includes('bg') || 
             key.includes('背景') ||
             key.includes('level') && (key.includes('image') || key.includes('img'))
    }
  },
  created() {
    this.loadConfigs()
  },
  methods: {
    async loadConfigs() {
      this.loading = true
      try {
        const data = await configApi.getAll()
        this.configs = Array.isArray(data) ? data : []
      } catch (e) {
        this.$message.error('加载配置失败: ' + (e.message || '未知错误'))
      } finally {
        this.loading = false
      }
    },
    handleAdd() {
      this.dialogTitle = '新增配置'
      this.form = {
        id: null,
        configKey: '',
        configValue: '',
        description: ''
      }
      this.dialogVisible = true
    },
    handleEdit(row) {
      this.dialogTitle = '编辑配置'
      this.form = {
        id: row.id,
        configKey: row.configKey || row.key || '',
        configValue: row.configValue || row.value || '',
        description: row.description || ''
      }
      this.dialogVisible = true
    },
    async handleDelete(row) {
      try {
        await this.$confirm('确定要删除这个配置吗？', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        })
        await configApi.delete(row.id)
        this.$message.success('删除成功')
        this.loadConfigs()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error('删除失败: ' + (error.message || '未知错误'))
        }
      }
    },
    async handleSubmit() {
      try {
        await this.$refs.form.validate()
        if (this.form.id) {
          await configApi.update(this.form.id, {
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          })
          this.$message.success('更新成功')
        } else {
          const created = await configApi.create({
            configKey: this.form.configKey,
            configValue: this.form.configValue,
            description: this.form.description
          })
          if (created && created.id) {
            this.$message.success('创建成功')
          } else {
            this.$message.success('创建成功')
          }
        }
        this.dialogVisible = false
        this.loadConfigs()
      } catch (e) {
        this.$message.error('操作失败: ' + (e.message || '未知错误'))
      }
    },
    beforeUpload(file) {
      const isImage = file.type.startsWith('image/')
      const isLt10M = file.size / 1024 / 1024 < 10
      if (!isImage) {
        this.$message.error('只能上传图片文件')
        return false
      }
      if (!isLt10M) {
        this.$message.error('文件大小不能超过 10MB')
        return false
      }
      return true
    },
    async handleCustomUpload(options) {
      try {
        // 上传图片，uploadApi 返回的是经过拦截器处理后的 data.data
        // 后端返回格式: { code: 200, data: "图片URL" }，拦截器处理后直接返回 "图片URL"
        const imageUrl = await uploadApi.uploadFile(options.file, (progress) => {
          console.log('上传进度:', progress + '%')
        })
        
        // 直接使用返回的图片链接
        if (typeof imageUrl === 'string') {
          this.form.configValue = imageUrl
        } else if (imageUrl && imageUrl.url) {
          // 兼容返回对象格式 { url: "图片URL" }
          this.form.configValue = imageUrl.url
        } else if (imageUrl && imageUrl.data) {
          // 兼容返回对象格式 { data: "图片URL" }
          this.form.configValue = typeof imageUrl.data === 'string' ? imageUrl.data : imageUrl.data.url
        } else {
          // 其他情况，转换为字符串
          this.form.configValue = String(imageUrl)
        }
        
        this.$message.success('上传成功')
      } catch (error) {
        this.$message.error('上传失败: ' + (error.message || '未知错误'))
      }
    },
    isImageUrl(url) {
      if (!url) return false
      return /\.(jpg|jpeg|png|gif|bmp|webp)$/i.test(url) || url.startsWith('http://') || url.startsWith('https://')
    },
    previewImage(url) {
      this.previewUrl = url
      this.previewVisible = true
    }
  }
}
</script>
<style scoped>
.config-management {
  padding: 20px;
}
.empty-state {
  margin-top: 50px;
}
.uploaded-preview {
  margin-top: 10px;
}
.preview-img {
  width: 200px;
  height: 150px;
  object-fit: cover;
  border-radius: 4px;
  cursor: pointer;
}
.media-container {
  text-align: center;
}
.preview-full-img {
  max-width: 100%;
  max-height: 500px;
}
</style>
